import { render } from "./headerSlider.vue?vue&type=template&id=170e6310"
const script = {}

import exportComponent from "C:\\blissappp\\theblissholidays\\bliss-site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__